import { IHeadlineProperties } from '@vfde-brix/ws10/headline';
import { getCMSConfig } from '../cms';

/**
 * Get the properties for the headline of the offer summary card component.
 *
 * @param isContentEnabled - Whether any tariff are available or not.
 * @param tariffName - The name of the selected tariff.
 * @returns - The properties to update of the headline element.
 */
export const getOfferSummaryCardHeadlineProps = (
    isContentEnabled: boolean,
    tariffName?: string,
): Partial<IHeadlineProperties> => ({
    stdContent: (isContentEnabled && tariffName)
        ? tariffName
        : getCMSConfig().offerSummaryCard.notAvailable.headline,
});
